/* @flow */
import React, { useContext, useEffect, useRef } from 'react';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { Root } from './styles';
import Intro from './Intro/Intro';
import Payment from './Payment';
import Questions from './Questions';
import Benefits from './Benefits';
import RetailServices from './RetailServices';
import AboutUs from './AboutUs';
import PackageServices from './PackageServices';
import type { TServices } from '../../types/services';
import { getServiceData } from '../../actions/services';
import type { TDispatch } from '../../types/core';
import { AppContext } from '../../components/AppContext';

const ServicesPage = (): Node => {
	const dispatch: TDispatch = useDispatch();
	const store = useStore();
	const context = useContext(AppContext);
	const services: TServices = useSelector((state) => state.services);
	const servicesRef = useRef(null);
	const scrollToServices = () => servicesRef.current.scrollIntoView({ behavior: 'smooth' });

	useEffect(() => {
		if (!services.isLoaded && !services.isLoading && Object.keys(services.data).length < 1) {
			getServiceData()(dispatch, store.getState, context);
		}
	}, []);

	return (
		<Root id="Root">
			<Intro clickToServices={scrollToServices} />
			<PackageServices innerRef={servicesRef} />
			<RetailServices />
			<Payment />
			<Benefits />
			<AboutUs />
			<Questions sectionType="intro" />
		</Root>
	);
};

export default ServicesPage;
